import { render, staticRenderFns } from "./InformationMeasureInfo.vue?vue&type=template&id=65f36ff8&"
import script from "./InformationMeasureInfo.vue?vue&type=script&lang=js&"
export * from "./InformationMeasureInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports